import { css } from '@emotion/react';
import React from 'react';

import { useTheme } from '@/ui/theme';
import { BodyExtraSmall, BodySmall } from '@/ui/typography';

export const Label = ({
  children,
  htmlFor,
  isRequired,
  description,
}: {
  children: string;
  htmlFor: string;
  isRequired?: boolean;
  description?: string;
}) => {
  const {
    colors,
    forms: { label: labelStyles },
  } = useTheme();
  return (
    <label
      css={css({
        display: 'block',
        paddingBottom: '8px',
        transition: 'opacity 0.2s ease',
        color: colors.textPrimary,
        zIndex: 1,
        ['&.filled']: { opacity: 1 },
        span: {
          color: labelStyles?.color,
          fontSize: labelStyles?.fontSize,
          lineHeight: labelStyles?.lineHeight,
          fontWeight: labelStyles?.fontWeight,
          letterSpacing: labelStyles?.letterSpacing,
        },
        ...labelStyles,
      })}
      htmlFor={htmlFor}
      // Unmask in FullStory
      className="fs-unmask"
    >
      <BodySmall>
        {children}
        {isRequired && <span aria-hidden="true">{'*'}</span>}
      </BodySmall>
      {description && labelStyles?.position !== 'absolute' && (
        <BodyExtraSmall>{description}</BodyExtraSmall>
      )}
    </label>
  );
};

export default Label;
